var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 12.8623C28.2188 12.8623 29.1354 13.779 30.0521 15.6123C30.0521 15.6123 32.9638 11.029 35.5521 10.1123",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0713 3.70591C14.4908 3.51198 10.9519 4.03965 10.9519 4.03965C8.71739 4.19942 4.43507 5.45217 4.43511 12.7684C4.43515 20.0225 4.38774 28.9655 4.43511 32.5306C4.43511 34.7088 5.78375 39.7895 10.4517 40.0618C16.1256 40.3929 26.3458 40.4633 31.0349 40.0618C32.2902 39.991 36.4692 39.0056 36.9982 34.4587C37.5461 29.7483 37.4371 26.4747 37.4371 25.6956",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0853 12.862C41.0853 17.9246 36.9774 22.0287 31.9098 22.0287C26.8423 22.0287 22.7344 17.9246 22.7344 12.862C22.7344 7.79938 26.8423 3.69531 31.9098 3.69531C36.9774 3.69531 41.0853 7.79938 41.0853 12.862Z",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5547 23.8623H20.888",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5547 31.1953H28.2213",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentValidation);
export default __webpack_public_path__ + "static/media/document-validation.a48db75595f2b47b660973cf257c3d14.svg";
export { ForwardRef as ReactComponent };